import { render, staticRenderFns } from "./BumperStickers.vue?vue&type=template&id=9a0c4fbc&scoped=true&"
import script from "./BumperStickers.vue?vue&type=script&lang=js&"
export * from "./BumperStickers.vue?vue&type=script&lang=js&"
import style0 from "./BumperStickers.vue?vue&type=style&index=0&id=9a0c4fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0c4fbc",
  null
  
)

component.options.__file = "BumperStickers.vue"
export default component.exports